import React from 'react';
import { COMMISSION_CALCULATION_METHOD_TYPES_QUERY, COMMISSION_CALCULATION_METHODS_QUERY } from '../queries';
import { Card } from '@totalsoft/rocket-ui';
import MethodModalComponent from './edit/MethodModalComponent';
import { CollectionType, getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ItemComponent from './ItemComponent';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const commissionCalculationMethodsStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'typeId',
      caption: 'CompetenceOrders.ApprovalTypeName',
      type: 'select',
      underlyingType: 'number'
    }
  ],
  orderByFields: [
    {
      caption: 'CommissionCalculationMethod.Name',
      value: 'Name'
    },
    {
      caption: 'CommissionCalculationMethod.Code',
      value: 'MethodCode'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});

const ListBrowserComponent = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: COMMISSION_CALCULATION_METHODS_QUERY,
        name: 'commissionCalculationMethods'
      },
      collectionsOptions: [
        {
          queryOptions: { query: COMMISSION_CALCULATION_METHOD_TYPES_QUERY },
          name: 'commissionCalculationMethodTypes',
          identifier: 'typeId',
          collectionType: CollectionType.Filter,
          valueKey: 'id',
          labelKey: 'name'
        }
      ]
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'name', caption: 'CommissionCalculationMethod.Name', width: 16 },
      { name: 'code', caption: 'CommissionCalculationMethod.Code', width: 10 },
      { name: 'type', caption: 'CommissionCalculationMethod.Type', width: 10 },
      { name: 'percentIsMandatory', caption: 'CommissionCalculationMethod.PercentIsMandatory', width: 8 },
      { name: 'assetIsMandatory', caption: 'CommissionCalculationMethod.AssetIsMandatory', width: 8 },
      { name: 'ppIsMandatory', caption: 'CommissionCalculationMethod.PPIsMandatory', width: 8 },
      { name: 'amountFormula', caption: 'CommissionCalculationMethod.AmountFormula', width: 25 },
      { name: 'percentFormula', caption: 'CommissionCalculationMethod.PercentFormula', width: 15 },
      { name: 'actions', caption: 'Actions', width: 15, align: 'right' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='commission-calculation-methods-browser'
        store={commissionCalculationMethodsStore}
        ItemComponent={ItemComponent}
        columns={columns}
      />
      <ExportModalComponent store={commissionCalculationMethodsStore} options={fetchingOptions} />
      <MethodModalComponent />
      <ApolloFetchingComponent store={commissionCalculationMethodsStore} options={fetchingOptions} />
    </Card>
  );
};

export default ListBrowserComponent;
